import { useEffect, useRef } from "react";
import { Check, CheckCircle2 } from "lucide-react";

type OrderConfirmationProps = {
  onClose: () => void;
};

export function OrderConfirmation({ onClose }: OrderConfirmationProps) {
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    closeButtonRef.current?.focus();

    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === "Escape") onClose();
    }

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return (
    <div className="confirmation-backdrop" role="presentation">
      <section
        className="order-confirmation"
        role="dialog"
        aria-modal="true"
        aria-labelledby="order-confirmation-title"
        aria-describedby="order-confirmation-description"
      >
        <span className="order-confirmation__icon" aria-hidden="true">
          <CheckCircle2 size={38} />
        </span>
        <span className="eyebrow">Beställningen är klar</span>
        <h2 id="order-confirmation-title">Tack för din beställning!</h2>
        <p id="order-confirmation-description">
          Vi har tagit emot din beställning och hör av oss när det är dags för leverans och betalning.
        </p>
        <button ref={closeButtonRef} className="primary-button" type="button" onClick={onClose}>
          <Check size={19} aria-hidden="true" />
          Fortsätt handla
        </button>
      </section>
    </div>
  );
}
